import { formatJsonDataset as fjd } from '../../components/renderers';

const actions = {
  add: 'Add',
  edit: 'Edit',
  del: 'Delete',
  delete: 'Delete',
  view: 'View',
};

const panels = {
  add: 'simple',
  edit: 'simple',
  delete: 'dialog',
  view: 'simple',
};

const crud = (service: any) => ({
  service: {
    num: true,
    pageMode: 'remote',
    ...service,
  },
  create: true,
  actions,
  panels,
  formatters: { grid: { exi: fjd } },
});

const statusField = () => ({
  id: 'sts',
  label: 'Status',
  type: 'fa',
  req: 1,
  ops: {},
  cp: { t: 'lcs', s: 'status' },
});

const extraInfoField = () => ({
  id: 'exi',
  label: 'Extra Info',
  type: 'jf',
  req: 0,
  ops: {},
});

const truthyField = (id: string, label: string, required = 1) => ({
  id,
  label,
  type: 'fa',
  req: required,
  ops: {},
  cp: { t: 'lcs', s: 'truthy' },
});

export const ordersconfig = {
  quotation: crud({
    name: 'quotation',
    title: 'Quotations and Proformas',
    num: false,
    fields: [
      'rid','rix','qtn','rvn','sqi','sqn','srv','dty','qtd','vud','cui',
      'cuc','cun','cci','ccn','loi','lon','loc','spi','spu','spn','pli',
      'pln','plc','cur','osi','osn','osc','fin','cls','can','ins','trm',
      'sub','dam','tam','ctc','tot','acd','cdn','ari','arn','dcd','exi',
      'sts','ast','stp','cri','crn',
    ],
    params: {
      qtn:'Quotation No.', dty:'Document Type', cui:'Customer',
      loi:'Location', spi:'Salesperson', osi:'Order Status',
      dtf:'Date From', dtt:'Date To', sts:'Status', ast:'Active Status',
    },
    grid: [
      ['qtn','Quotation No.'], ['rvn','Revision'], ['dty','Document Type'],
      ['qtd','Quotation Date'], ['vud','Valid Until'], ['cun','Customer'],
      ['lon','Location'], ['spn','Salesperson'], ['osn','Order Status'],
      ['cur','Currency'], ['sub','Subtotal'], ['dam','Discount'],
      ['tam','Tax'], ['ctc','Cutting Charge'], ['tot','Total'],
      ['sts','Status'], ['stp','Stamp'],
    ],
    menu: {
      mnu: [
        { t:'Quotation No.', v:'qtn' },
        { t:'Customer', v:'cun' },
        { t:'Document Type', v:'dty' },
        { t:'Order Status', v:'osn' },
      ],
      def:'qtn',
    },
    eform: [
      { id:'qtn', label:'Quotation No.', type:'tf', req:1, ops:{} },
      { id:'rvn', label:'Revision No.', type:'nf', req:1, ops:{} },
      { id:'sqi', label:'Supersedes Quotation', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'supersedesquotation' } },
      { id:'dty', label:'Document Type', type:'fa', req:1, ops:{}, cp:{ t:'lcs', s:'quotationdocumenttype' } },
      { id:'qtd', label:'Quotation Date', type:'df', req:1, ops:{} },
      { id:'vud', label:'Valid Until', type:'df', req:0, ops:{} },
      { id:'cui', label:'Customer', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'customer' } },
      { id:'cci', label:'Customer Contact', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'ordercustomercontact' } },
      { id:'loi', label:'Location', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'orderlocation' } },
      { id:'spi', label:'Salesperson', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'salesperson' } },
      { id:'pli', label:'Price List', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'pricelist' } },
      { id:'cri', label:'Currency', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'currency' } },
      { id:'osi', label:'Order Status', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'orderstatus' } },
      { id:'ins', label:'Special Instructions', type:'ta', req:0, ops:{} },
      { id:'trm', label:'Terms and Conditions', type:'ta', req:0, ops:{} },
      { id:'sub', label:'Subtotal', type:'nf', req:1, ops:{} },
      { id:'dam', label:'Discount Amount', type:'nf', req:1, ops:{} },
      { id:'tam', label:'Tax Amount', type:'nf', req:1, ops:{} },
      { id:'ctc', label:'Cutting Charge', type:'nf', req:1, ops:{} },
      { id:'tot', label:'Total Amount', type:'nf', req:1, ops:{} },
      { id:'acd', label:'Accepted Date', type:'df', req:0, ops:{} },
      { id:'cdn', label:'Customer Decision Notes', type:'ta', req:0, ops:{} },
      { id:'ari', label:'Approval Request', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'approvalrequest' } },
      extraInfoField(),
      statusField(),
    ],
  }),

  salesorder: crud({
    name: 'salesorder',
    title: 'Sales Orders',
    num: false,
    fields: [
      'rid','rix','orn','ord','src','qti','qtn','rvn','cui','cuc','cun',
      'cci','ccn','loi','lon','loc','spi','spu','spn','pli','pln','plc',
      'cur','osi','osn','osc','fin','cls','can','efd','ins','crs','crd',
      'rap','ari','arn','abi','abu','abn','apd','sub','dam','tam','ctc',
      'tot','nts','dcd','exi','sts','ast','stp','cri','crn',
    ],
    params: {
      orn:'Order No.', cui:'Customer', loi:'Location', spi:'Salesperson',
      osi:'Order Status', src:'Order Source', qti:'Quotation',
      dtf:'Date From', dtt:'Date To', sts:'Status', ast:'Active Status',
    },
    grid: [
      ['orn','Order No.'], ['ord','Order Date'], ['src','Source'],
      ['qtn','Quotation'], ['cun','Customer'], ['lon','Location'],
      ['spn','Salesperson'], ['osn','Order Status'],
      ['efd','Expected Fulfillment'], ['crs','Credit Sale'], ['crd','Credit Days'],
      ['cur','Currency'], ['sub','Subtotal'], ['dam','Discount'],
      ['tam','Tax'], ['ctc','Cutting Charge'], ['tot','Total'],
      ['sts','Status'], ['stp','Stamp'],
    ],
    menu: {
      mnu: [
        { t:'Order No.', v:'orn' },
        { t:'Customer', v:'cun' },
        { t:'Quotation', v:'qtn' },
        { t:'Order Status', v:'osn' },
      ],
      def:'orn',
    },
    eform: [
      { id:'orn', label:'Order No.', type:'tf', req:1, ops:{} },
      { id:'ord', label:'Order Date', type:'df', req:1, ops:{} },
      { id:'src', label:'Order Source', type:'fa', req:1, ops:{}, on:['add'], cp:{ t:'lcs', s:'directordersource' } },
      { id:'src', label:'Order Source', type:'rf', req:0, ops:{}, on:['edit'] },
      { id:'qtn', label:'Source Quotation', type:'rf', req:0, ops:{}, on:['edit'] },
      { id:'cui', label:'Customer', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'customer' } },
      { id:'cci', label:'Customer Contact', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'ordercustomercontact' } },
      { id:'loi', label:'Location', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'orderlocation' } },
      { id:'spi', label:'Salesperson', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'salesperson' } },
      { id:'pli', label:'Price List', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'pricelist' } },
      { id:'cri', label:'Currency', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'currency' } },
      { id:'osi', label:'Order Status', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'orderstatus' } },
      { id:'efd', label:'Expected Fulfillment Date', type:'df', req:0, ops:{} },
      { id:'ins', label:'Special Instructions', type:'ta', req:0, ops:{} },
      truthyField('crs','Credit Sale'),
      { id:'crd', label:'Credit Days', type:'nf', req:1, ops:{} },
      truthyField('rap','Requires Approval'),
      { id:'ari', label:'Approval Request', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'approvalrequest' } },
      { id:'abi', label:'Approved By', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'approveduser' } },
      { id:'apd', label:'Approved Date', type:'df', req:0, ops:{} },
      { id:'sub', label:'Subtotal', type:'nf', req:1, ops:{} },
      { id:'dam', label:'Discount Amount', type:'nf', req:1, ops:{} },
      { id:'tam', label:'Tax Amount', type:'nf', req:1, ops:{} },
      { id:'ctc', label:'Cutting Charge', type:'nf', req:1, ops:{} },
      { id:'tot', label:'Total Amount', type:'nf', req:1, ops:{} },
      { id:'nts', label:'Notes', type:'ta', req:0, ops:{} },
      extraInfoField(),
      statusField(),
    ],
  }),

  salesorderitem: crud({
    name: 'salesorderitem',
    title: 'Sales Order Items',
    num: false,
    fields: [
      'rid','rix','soi','orn','qii','qln','lin','pri','prc','prn','pvi',
      'pvc','pvn','uni','unn','unc','ids','qty','rsv','ful','urq','ufq',
      'wid','len','thk','dui','dun','duc','upr','dpc','dam','tpc','tam',
      'ctr','cti','ctc','lam','nts','dcd','exi','sts','ast','stp',
    ],
    params: {
      soi:'Sales Order', pri:'Product', pvi:'Product Variant',
      ctr:'Cutting Required', rsp:'Reservation Pending',
      fup:'Fulfillment Pending', sts:'Status', ast:'Active Status',
    },
    grid: [
      ['orn','Sales Order'], ['lin','Line No.'], ['prc','Product Code'],
      ['prn','Product'], ['pvn','Variant'], ['ids','Description'],
      ['qty','Quantity'], ['rsv','Reserved'], ['urq','Unreserved'],
      ['ful','Fulfilled'], ['ufq','Unfulfilled'], ['unn','Unit'],
      ['upr','Unit Price'], ['dpc','Discount %'], ['dam','Discount'],
      ['tpc','Tax %'], ['tam','Tax'], ['ctr','Cutting Required'],
      ['ctc','Cutting Charge'], ['lam','Line Amount'], ['sts','Status'],
      ['stp','Stamp'],
    ],
    menu: {
      mnu: [
        { t:'Sales Order', v:'orn' },
        { t:'Product', v:'prn' },
        { t:'Product Code', v:'prc' },
        { t:'Variant', v:'pvn' },
      ],
      def:'orn',
    },
    eform: [
      { id:'soi', label:'Sales Order', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'salesorder' } },
      { id:'qln', label:'Quotation Line', type:'rf', req:0, ops:{}, on:['edit'] },
      { id:'lin', label:'Line No.', type:'nf', req:1, ops:{} },
      { id:'pri', label:'Product', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'product' } },
      { id:'pvi', label:'Product Variant', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'productvariant' } },
      { id:'uni', label:'Unit of Measure', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'unitofmeasure' } },
      { id:'ids', label:'Item Description', type:'ta', req:0, ops:{} },
      { id:'qty', label:'Quantity', type:'nf', req:1, ops:{} },
      { id:'rsv', label:'Reserved Quantity', type:'rf', req:0, ops:{}, on:['edit'] },
      { id:'ful', label:'Fulfilled Quantity', type:'rf', req:0, ops:{}, on:['edit'] },
      { id:'wid', label:'Width', type:'nf', req:0, ops:{} },
      { id:'len', label:'Length', type:'nf', req:0, ops:{} },
      { id:'thk', label:'Thickness', type:'nf', req:0, ops:{} },
      { id:'dui', label:'Dimension Unit', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'unitofmeasure' } },
      { id:'upr', label:'Unit Price', type:'nf', req:1, ops:{} },
      { id:'dpc', label:'Discount Percent', type:'nf', req:0, ops:{} },
      { id:'dam', label:'Discount Amount', type:'nf', req:0, ops:{} },
      { id:'tpc', label:'Tax Percent', type:'nf', req:0, ops:{} },
      { id:'tam', label:'Tax Amount', type:'nf', req:0, ops:{} },
      truthyField('ctr','Cutting Required'),
      { id:'cti', label:'Cutting Instructions', type:'ta', req:0, ops:{} },
      { id:'ctc', label:'Cutting Charge', type:'nf', req:1, ops:{} },
      { id:'lam', label:'Line Amount', type:'nf', req:1, ops:{} },
      { id:'nts', label:'Notes', type:'ta', req:0, ops:{} },
      extraInfoField(),
      statusField(),
    ],
  }),

  orderfulfillment: crud({
    name: 'orderfulfillment',
    title: 'Order Fulfillments',
    num: false,
    fields: [
      'rid','rix','fno','soi','orn','cui','cuc','cun','loi','lon','loc',
      'fud','osi','osn','osc','fin','cls','rbp','ari','arn','rbi','rbu',
      'rbn','rld','rcn','nts','dcd','exi','sts','ast','stp',
    ],
    params: {
      fno:'Fulfillment No.', soi:'Sales Order', cui:'Customer',
      loi:'Location', osi:'Order Status', dtf:'Date From', dtt:'Date To',
      sts:'Status', ast:'Active Status',
    },
    grid: [
      ['fno','Fulfillment No.'], ['orn','Sales Order'], ['cun','Customer'],
      ['lon','Location'], ['fud','Fulfillment Date'], ['osn','Order Status'],
      ['rbp','Released Before Payment'], ['rbn','Released By'],
      ['rld','Released Date'], ['rcn','Received By'],
      ['sts','Status'], ['stp','Stamp'],
    ],
    menu: {
      mnu: [
        { t:'Fulfillment No.', v:'fno' },
        { t:'Sales Order', v:'orn' },
        { t:'Customer', v:'cun' },
        { t:'Order Status', v:'osn' },
      ],
      def:'fno',
    },
    eform: [
      { id:'fno', label:'Fulfillment No.', type:'tf', req:1, ops:{} },
      { id:'soi', label:'Sales Order', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'salesorder' } },
      { id:'loi', label:'Location', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'orderlocation' } },
      { id:'fud', label:'Fulfillment Date', type:'df', req:1, ops:{} },
      { id:'osi', label:'Order Status', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'orderstatus' } },
      truthyField('rbp','Released Before Payment'),
      { id:'ari', label:'Approval Request', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'approvalrequest' } },
      { id:'rbi', label:'Released By', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'releaseduser' } },
      { id:'rld', label:'Released Date', type:'df', req:0, ops:{} },
      { id:'rcn', label:'Received By Name', type:'tf', req:0, ops:{} },
      { id:'nts', label:'Notes', type:'ta', req:0, ops:{} },
      extraInfoField(),
      statusField(),
    ],
  }),
};

export default ordersconfig;
